module.exports = __webpack_public_path__ + "static/img/purchase-price.af7c867c.png";